<template>
  <div id="app">
    <div ref="container" id="app-container" class="app-container">
      <div class="top-bar" :style="{width: percent * 100 + '%'}"></div>
      <div v-show="!showHeader" class="back" @click="backToTop">
        <div class="quan">
          <div class="con">
            <i class="el-icon-top"></i>
            <i class="el-icon-top"></i>
          </div>
          <span>{{ $theme ? '置顶' : 'TOP' }}</span>
        </div>
      </div>
      <app-header v-show="showHeader"></app-header>
      <el-main>
        <!--                <keep-alive>-->
        <!--                  <router-view v-if="$route.meta.keepAlive" />-->
        <!--                </keep-alive>-->
        <!--        <router-view v-if="!$route.meta.keepAlive" />-->
        <transition name="slide">
          <!--          <keep-alive>-->
          <router-view class="child-view"/>
          <!--          </keep-alive>-->
        </transition>
      </el-main>
      <!-- <app-footer v-if="!isHome"></app-footer> -->
      <!-- <ModelSix v-if="!isHome"></ModelSix> -->
    </div>
    <div v-if="photoViewVisible">
      <photo-view
          :photoViewVisible.sync="photoViewVisible"
          :photoViewSrc="photoViewSrc"
      ></photo-view>
    </div>
  </div>
</template>

<script>
import {getSchemeTreeNew, getSolutionDetail} from '@/api/solution.js';
import {getHardwareTree, getSoftwareTree} from '@/api/product.js';
// import AppFooter from '@/components/app-footer/Index.vue';
import AppHeader from '@/components/app-header/Index.vue';
import PhotoView from '@/components/photo-view/Index.vue';

export default {
  name: 'App',
  components: {
    // AppFooter,
    AppHeader,
    PhotoView,
  },
  data() {
    return {
      showHeader: true,
      percent: 0,
      element: null
    };
  },
  watch: {
    $route(to, from) {
      this.element.removeEventListener('scroll', this.onScroll);
      this.percent = 0
      setTimeout(()=>{
        this.element = document.getElementsByClassName("child-view")[0];
        this.element.addEventListener("scroll", (e) => {
          this.onScroll(e);
        })
      }, 1000)
    }
  },
  computed: {
    isHome: function () {
      return ['/', '/home'].includes(this.$route.path);
    },
    photoViewVisible: function () {
      return this.$store.state.photoViewVisible;
    },
    photoViewSrc: function () {
      return this.$store.state.photoViewSrc;
    }
  },
  created() {
    this.getSchemeTree();
    this.getSchemeDetail()
    this.$bus.$on('change-process',()=>{
      this.percent = 1
    })
  },
  mounted() {
    this.element = document.getElementsByClassName("child-view")[0];
    this.element.addEventListener("scroll", (e) => {
      this.onScroll();
    },true)
    // this.getProductionTree();
    this.$bus.$on('change-show-header', (val) => {
      this.showHeader = val
    })
  },
  methods: {
    backToTop() {
      document.getElementsByClassName("child-view")[0].scrollTo({left: 0, top: 0, behavior: 'smooth'})
    },
    onScroll() {
      const {element} = this
      var scrollTop = element.scrollTop;
      var scrollHeight = element.scrollHeight;
      var clientHeight = element.clientHeight;
      this.percent = scrollTop / (scrollHeight - clientHeight)
    },
    headerClick(item) {
      this.activeIndex = item.url;
      this.$router.push(item.url);
    },
    // 获取解决方案树
    getSchemeTree() {
      getSchemeTreeNew().then(res => {
        this.$store.dispatch('setSolutionTree', res.data);
        sessionStorage.setItem('solutionTree', JSON.stringify(res.data));
      });

    },
    // 获取解决方案详情
    getSchemeDetail() {
      getSolutionDetail().then(res => {
        sessionStorage.setItem('solutionDetail', JSON.stringify(res.data));
      });

    },
    // 获取 产品中心 树
    getProductionTree() {
      getHardwareTree().then(res => {
        let list = res.data || [];
        this.$store.dispatch('setProductionHardwareList', list);
      });

      getSoftwareTree().then(res => {
        let list = res.data || [];
        this.$store.dispatch('setProductionSoftwareList', list);
      });
    }
  },
}
</script>
<style lang="scss">
@import "./assets/css/common.scss";
@import "./assets/css/app.scss";
</style>
